import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from 'context/AuthContext';
import { DonationProvider } from 'context/DonationContext';
import AppRoutes from 'app/routes';

// Shared multi-page stylesheets load eagerly (single deterministic cascade
// position — lazy chunks importing them in different orders caused
// mini-css-extract "conflicting order" warnings, which CI builds treat as
// errors). Order mirrors the pre-split App.js: page-level CSS before global.css.
import 'features/auth/auth.css';
import 'features/events/eventForm.css';
import 'features/gyms/gymProfile.css';
import 'features/gyms/pages/PublicProfile/styles.css';
import 'features/static/legal.css';
import 'features/admin/admin.css';
import 'styles/global.css';
import { DonationDialog } from '../components/DonationDialog';

const App = () => (
  <HelmetProvider>
    <BrowserRouter>
      <AuthProvider>
        <DonationProvider>
          <DonationDialog />
          <AppRoutes />
        </DonationProvider>
      </AuthProvider>
    </BrowserRouter>
  </HelmetProvider>
);

export default App;
